export const ACTIVE_COMPANY_KEY = 'activeCompanyId'
export const ACTIVE_OFFICE_KEY = 'activeOfficeId'
export const PORTAL_ACCOUNT_KEY = 'portalAccountId'

// The headers that say WHO and WHERE this request is for. They were built inline in the apiRequest
// interceptor, which is fine until something bypasses apiRequest — the two document-upload thunks
// call axios directly with hand-built headers, so they carried no office and no brand. A file
// uploaded through them was attributed to whatever the server guessed.
//
// One source of truth, so a caller that builds its own headers can still get these right.
export const ambientHeaders = () => {
  const headers = {}

  const portalAccountId = localStorage.getItem(PORTAL_ACCOUNT_KEY)
  if (portalAccountId) headers['X-Account-Id'] = portalAccountId

  const activeOfficeId = localStorage.getItem(ACTIVE_OFFICE_KEY)
  if (activeOfficeId) headers['X-Office-Id'] = activeOfficeId

  // Sent only when a brand has been chosen: an absent header means "the one firm I belong to",
  // which is every caller today, while an empty one would name a firm nobody selected.
  const activeCompanyId = localStorage.getItem(ACTIVE_COMPANY_KEY)
  if (activeCompanyId) headers['x-company-id'] = activeCompanyId

  return headers
}

// Firm-scoped state that lives in sessionStorage, which a same-tab reload does NOT clear. The
// contacts list remembers its saved-filter selection there, and a saved filter belongs to one firm —
// so after a brand switch the id was restored, the server looked it up inside the NEW firm, found
// nothing, and the list threw on a null filter list.
const FIRM_SCOPED_SESSION_KEYS = ['contactsListState']

// Everything that identifies WHICH user and WHICH firm this browser is acting as. Cleared together,
// because they are only ever correct together: a brand or an office left behind when the identity
// changes means the next person acts as the previous one until something refuses them.
export const clearAmbientSelection = () => {
  localStorage.removeItem(ACTIVE_OFFICE_KEY)
  localStorage.removeItem(ACTIVE_COMPANY_KEY)

  try {
    FIRM_SCOPED_SESSION_KEYS.forEach((key) => sessionStorage.removeItem(key))
  } catch (unavailable) { /* private-mode Safari refuses sessionStorage; nothing to clear there */ }
}
